import React from 'react'
import PropTypes from 'prop-types'

const Card = ( {img} ) => {
    
    return (
        <>
         <div className="card m-2 p-2 ms-auto me-auto overflow-hidden" style={{width: '20rem',}}>
            
            <img src={img} className="card-img-top m-auto" alt="imagen" />
        </div>   
        </>
    )
}

Card.propTypes = {
    img: PropTypes.string,
}

export default Card
